import ExpandableImage from 'styled-elements/ExpandableImage'
import ExpandableVideo from 'styled-elements/ExpandableVideo'
import styled from 'typed-emotion'
import { Scale } from 'styled-elements/ScaledImage'

interface ImageProps {
  height: number
  width: number
}

export const Image = styled(ExpandableImage)<ImageProps>`
  display: block;
  margin: 10px 0;
  cursor: pointer;
  border-radius: 3px;
  ${props =>
    new Scale({
      ...props,
      maxWidth: 400,
      maxHeight: 300
    }).css};

  @media (max-width: 700px) {
    width: 65%;
    height: auto;
  }

  @media (max-width: 650px) {
    width: 70%;
  }

  @media (max-width: 600px) {
    width: 80%;
  }
`

interface VideoProps {
  height: number
  width: number
  controls?: boolean
}

export const Video = styled(ExpandableVideo)<VideoProps>`
  display: block;
  margin: 10px 0;
  cursor: ${props => (props.controls ? 'default' : 'pointer')};
  border-radius: 3px;
  ${props =>
    new Scale({
      ...props,
      maxWidth: 400,
      maxHeight: 300
    }).css};

  @media (max-width: 700px) {
    width: 65%;
    height: auto;
  }

  @media (max-width: 650px) {
    width: 70%;
  }

  @media (max-width: 600px) {
    width: 80%;
  }
`

interface IframeProps {
  height: number
  width: number
}

export const IframeVideo = styled.iframe<IframeProps>`
  display: block;
  margin: 10px 0;
  border: 0;
  border-radius: 3px;
  ${props =>
    new Scale({
      ...props,
      maxWidth: 400,
      maxHeight: 300
    }).css};

  @media (max-width: 700px) {
    width: 65%;
    height: auto;
  }

  @media (max-width: 650px) {
    width: 70%;
  }

  @media (max-width: 600px) {
    width: 80%;
  }
`



// WEBPACK FOOTER //
// ./src/components/Markdown/render/elements/media.ts